export const designTokens = `
  :root {
    /* ── Navy ── */
    --navy:       #1a2252;
    --navy-deep:  #111840;
    --navy-light: #243070;
    --navy-50:  #eef0f5;
    --navy-100: #dde1eb;
    --navy-200: #c4c9d8;
    --navy-300: #9098b0;
    --navy-400: #6b7490;
    --navy-500: #4e5672;
    --navy-600: #353d58;
    --navy-700: #243070;
    --navy-800: #1a2252;
    --navy-900: #111840;

    /* ── Red ── */
    --red:       #e4202c;
    --red-dark:  #c41820;
    --red-light: #ff3a46;
    --red-50:  #fef3f2;
    --red-100: #fecaca;
    --red-200: #f89e9e;
    --red-300: #f57777;
    --red-400: #f25959;
    --red-500: #e4202c;
    --red-600: #c41820;
    --red-700: #a01018;
    --red-800: #7c0c12;
    --red-900: #580808;

    /* ── Gray ── */
    --gray-50:  #f7f8fb;
    --gray-100: #eef0f5;
    --gray-200: #dde1eb;
    --gray-300: #c4c9d8;
    --gray-400: #9098b0;
    --gray-500: #6b7490;
    --gray-600: #4e5672;
    --gray-700: #353d58;
    --gray-800: #343a40;
    --gray-900: #212529;

    /* ── Semantic ── */
    --success-500: #0ea572;
    --success-600: #0bc98a;
    --warning-500: #f59e0b;
    --warning-600: #d97706;
    --info-500:    #3b82f6;
    --info-600:    #2563eb;

    /* ── Background ── */
    --bg-page:  #f3f4f8;
    --card-bg:  #ffffff;
    --border:       rgba(26,34,82,0.08);
    --border-hover: rgba(26,34,82,0.18);

    /* ── Fonts ── */
    --font-display: 'Barlow Condensed', sans-serif;
    --font-body:    'Barlow', 'Inter', sans-serif;
    --font-mono:    'JetBrains Mono', monospace;

    /* ── Spacing (4px base) ── */
    --space-1:  4px;
    --space-2:  8px;
    --space-3:  12px;
    --space-4:  16px;
    --space-5:  20px;
    --space-6:  24px;
    --space-8:  32px;
    --space-10: 40px;
    --space-12: 48px;
    --space-16: 64px;

    /* ── Radius ── */
    --radius-sm:   8px;
    --radius-md:   12px;
    --radius-lg:   16px;
    --radius-xl:   20px;
    --radius-2xl:  24px;
    --radius-full: 9999px;

    /* ── Shadows ── */
    --shadow-sm:   0 1px 3px rgba(26,34,82,0.06);
    --shadow-md:   0 4px 16px rgba(26,34,82,0.08);
    --shadow-lg:   0 8px 32px rgba(26,34,82,0.12);
    --shadow-xl:   0 16px 48px rgba(26,34,82,0.16);
    --shadow-2xl:  0 25px 50px rgba(0,0,0,.25);
    --shadow-red:  0 4px 16px rgba(228,32,44,0.35);
    --shadow-navy: 0 4px 14px rgba(26,34,82,0.35);

    /* ── Transitions ── */
    --transition:     all 0.25s cubic-bezier(0.4,0,0.2,1);
    --ease-out:       cubic-bezier(0.4,0,0.2,1);
    --duration-fast:  150ms;
    --duration-normal:250ms;
    --duration-slow:  400ms;
  }
`;
